"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Standards = exports.UK = exports.FDA = exports.computeFractionalIntake = void 0;
const Record = __importStar(require("effect/Record"));
const Energy = __importStar(require("../unit/energy"));
const Mass = __importStar(require("../unit/mass"));
/**
 * Provides the {@link FractionalIntake}
 * for each nutrient within the provided {@link NutritionalInfo}
 * according to the provided {@link RecommendedDailyIntake RDI} standard.
 *
 * values less than 1 are below the provided RDI standard,
 * and a values greater than 1 are above the provided RDI standard.
 *
 * `null`-values imply that the provided RDI standard
 * does not specify an RDI recommendation for the nutrient.
 */
const computeFractionalIntake = (nutritionalInfo, reference) => ({
    energy: reference.energy === null
        ? null
        : Energy.divide(nutritionalInfo.energy, reference.energy).amount,
    macro: {
        protein: reference.macro.protein === null
            ? null
            : Mass.divide(nutritionalInfo.macro.protein, reference.macro.protein).amount,
        carbohydrate: Record.map(nutritionalInfo.macro.carbohydrate, (mass, key) => reference.macro.carbohydrate[key] === null
            ? null
            : Mass.divide(mass, reference.macro.carbohydrate[key]).amount),
        fat: Record.map(nutritionalInfo.macro.fat, (mass, key) => reference.macro.fat[key] === null
            ? null
            : Mass.divide(mass, reference.macro.fat[key]).amount),
    },
    micro: Record.map(nutritionalInfo.micro, (mass, key) => reference.micro[key] === null ? null : Mass.divide(mass, reference.micro[key]).amount),
});
exports.computeFractionalIntake = computeFractionalIntake;
/**
 * Nutrient {@link RecommendedDailyIntake RDI} standard for the U.S. Food and Drug Administration
 *
 * Reference:
 * https://www.fda.gov/food/nutrition-facts-label/daily-value-nutrition-and-supplement-facts-labels
 */
exports.FDA = {
    energy: Energy.Kilocalorie.make({ amount: 2_000 }),
    macro: {
        protein: Mass.Gram.make({ amount: 50 }),
        carbohydrate: {
            sugar: null,
            fiber: Mass.Gram.make({ amount: 28 }),
            total: Mass.Gram.make({ amount: 275 }),
        },
        fat: {
            saturated: Mass.Gram.make({ amount: 20 }),
            unsaturated: null,
            total: Mass.Gram.make({ amount: 78 }),
        },
    },
    micro: {
        biotin: Mass.Microgram.make({ amount: 30 }),
        calcium: Mass.Milligram.make({ amount: 1_300 }),
        caffeine: Mass.Milligram.make({ amount: 400 }),
        chloride: Mass.Milligram.make({ amount: 2_300 }),
        choline: Mass.Milligram.make({ amount: 550 }),
        cholesterol: Mass.Milligram.make({ amount: 300 }),
        chromium: Mass.Microgram.make({ amount: 35 }),
        copper: Mass.Milligram.make({ amount: 0.9 }),
        fluoride: null,
        folicAcid: Mass.Microgram.make({ amount: 400 }),
        iodine: Mass.Microgram.make({ amount: 150 }),
        iron: Mass.Milligram.make({ amount: 18 }),
        magnesium: Mass.Milligram.make({ amount: 420 }),
        manganese: Mass.Milligram.make({ amount: 2.3 }),
        molybdenum: Mass.Microgram.make({ amount: 45 }),
        niacin: Mass.Milligram.make({ amount: 16 }),
        pantothenicAcid: Mass.Milligram.make({ amount: 5 }),
        phosphorus: Mass.Milligram.make({ amount: 1_250 }),
        potassium: Mass.Milligram.make({ amount: 4_700 }),
        riboflavin: Mass.Milligram.make({ amount: 1.3 }),
        // FDA sets no Daily Value for salt, only for sodium.
        salt: null,
        selenium: Mass.Microgram.make({ amount: 55 }),
        sodium: Mass.Milligram.make({ amount: 2_300 }),
        thiamin: Mass.Milligram.make({ amount: 1.2 }),
        vitaminA: Mass.Microgram.make({ amount: 900 }),
        vitaminB6: Mass.Milligram.make({ amount: 1.7 }),
        vitaminB12: Mass.Microgram.make({ amount: 2.4 }),
        vitaminC: Mass.Milligram.make({ amount: 90 }),
        vitaminD: Mass.Microgram.make({ amount: 20 }),
        vitaminE: Mass.Milligram.make({ amount: 15 }),
        vitaminK: Mass.Microgram.make({ amount: 120 }),
        zinc: Mass.Milligram.make({ amount: 11 }),
    },
};
/**
 * Nutrient {@link RecommendedDailyIntake RDI} standard for UK food labeling
 *
 * Reference:
 * https://www.legislation.gov.uk/eur/2011/1169/annex/XIII
 */
exports.UK = {
    energy: Energy.Kilocalorie.make({ amount: 2_000 }),
    macro: {
        protein: Mass.Gram.make({ amount: 50 }),
        carbohydrate: {
            sugar: Mass.Gram.make({ amount: 90 }),
            fiber: null,
            total: Mass.Gram.make({ amount: 260 }),
        },
        fat: {
            saturated: Mass.Gram.make({ amount: 20 }),
            unsaturated: null,
            total: Mass.Gram.make({ amount: 70 }),
        },
    },
    micro: {
        biotin: Mass.Microgram.make({ amount: 50 }),
        calcium: Mass.Milligram.make({ amount: 800 }),
        caffeine: null,
        chloride: Mass.Milligram.make({ amount: 800 }),
        choline: null,
        cholesterol: null,
        chromium: Mass.Microgram.make({ amount: 40 }),
        copper: Mass.Milligram.make({ amount: 1 }),
        fluoride: Mass.Milligram.make({ amount: 3.5 }),
        folicAcid: Mass.Microgram.make({ amount: 200 }),
        iodine: Mass.Microgram.make({ amount: 150 }),
        iron: Mass.Milligram.make({ amount: 14 }),
        magnesium: Mass.Milligram.make({ amount: 375 }),
        manganese: Mass.Milligram.make({ amount: 2 }),
        molybdenum: Mass.Microgram.make({ amount: 50 }),
        niacin: Mass.Milligram.make({ amount: 16 }),
        pantothenicAcid: Mass.Milligram.make({ amount: 6 }),
        phosphorus: Mass.Milligram.make({ amount: 700 }),
        potassium: Mass.Milligram.make({ amount: 2_000 }),
        riboflavin: Mass.Milligram.make({ amount: 1.4 }),
        salt: Mass.Gram.make({ amount: 6 }),
        selenium: Mass.Microgram.make({ amount: 55 }),
        sodium: null,
        thiamin: Mass.Milligram.make({ amount: 1.1 }),
        vitaminA: Mass.Microgram.make({ amount: 800 }),
        vitaminB6: Mass.Milligram.make({ amount: 1.4 }),
        vitaminB12: Mass.Microgram.make({ amount: 2.5 }),
        vitaminC: Mass.Milligram.make({ amount: 80 }),
        vitaminD: Mass.Microgram.make({ amount: 5 }),
        vitaminE: Mass.Milligram.make({ amount: 12 }),
        vitaminK: Mass.Microgram.make({ amount: 75 }),
        zinc: Mass.Milligram.make({ amount: 10 }),
    },
};
exports.Standards = { FDA: exports.FDA, UK: exports.UK };
//# sourceMappingURL=rdi.js.map